/**
 * Emoji data index - exports all categories with searchable keywords
 */
import { smileys } from './smileys';
import { gestures } from './gestures';
import { people } from './people';
import { animals } from './animals';
import { nature } from './nature';
import { food } from './food';
import { activities } from './activities';
import { travel } from './travel';
import { objects } from './objects';
import { symbols } from './symbols';
import { flags } from './flags';

/**
 * All emoji categories with keywords
 */
export const EMOJI_CATEGORIES = {
  Smileys: smileys,
  Gestures: gestures,
  People: people,
  Animals: animals,
  Nature: nature,
  Food: food,
  Activities: activities,
  Travel: travel,
  Objects: objects,
  Symbols: symbols,
  Flags: flags,
};

/**
 * Get category names in order
 */
export const CATEGORY_NAMES = Object.keys(EMOJI_CATEGORIES);

/**
 * Search emojis by keyword across all categories
 * @param {string} query - Search query
 * @returns {Array} Array of matching emoji objects { emoji, keywords, category }
 */
export const searchEmojis = (query) => {
  if (!query || !query.trim()) return [];
  
  const normalizedQuery = query.toLowerCase().trim();
  const results = [];
  
  Object.entries(EMOJI_CATEGORIES).forEach(([categoryName, category]) => {
    category.emojis.forEach((emojiData) => {
      // Check if any keyword matches the query
      const matches = emojiData.keywords.some(keyword => 
        keyword.toLowerCase().includes(normalizedQuery)
      );
      
      if (matches) {
        results.push({
          ...emojiData,
          category: categoryName,
        });
      }
    });
  });
  
  return results;
};

/**
 * Get emojis for a specific category (just the emoji strings for display)
 * @param {string} categoryName - Category name
 * @returns {Array} Array of emoji data objects
 */
export const getEmojisByCategory = (categoryName) => {
  const category = EMOJI_CATEGORIES[categoryName];
  return category ? category.emojis : [];
};

/**
 * Get category icon
 * @param {string} categoryName - Category name
 * @returns {string} Category icon emoji
 */
export const getCategoryIcon = (categoryName) => {
  const category = EMOJI_CATEGORIES[categoryName];
  return category ? category.icon : '❓';
};

export default EMOJI_CATEGORIES;

